import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';

@Injectable()
export class UserUnlockService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'Application/json',
    }),
  };

  constructor(private http: HttpClient) {}

  sendUnlockEmail(email) {
    const body = { email };

    return this.http.post(
      environment.localSbxUrl + environment.unlockAPI + environment.unlockPath,
      body,
      this.httpOptions,
    );
  }
}
